var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 33,
    viewBox: "0 0 92 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_125",
    "data-name": "Rettangolo 125",
    width: 26,
    height: 26,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "job",
    transform: "translate(-692 -397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_51",
    "data-name": "Rettangolo 51",
    width: 92,
    height: 33,
    transform: "translate(692 397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_93",
    "data-name": "Raggruppa 93",
    transform: "translate(725 401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_92",
    "data-name": "Raggruppa 92",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_395",
    "data-name": "Tracciato 395",
    d: "M3.4,18.006a.99.99,0,0,0,.62-.216L21.379,4.049,21.228,5.71A1,1,0,0,0,22.134,6.8l.091,0a1,1,0,0,0,.995-.909l.354-3.909a.983.983,0,0,0-.19-.8.919.919,0,0,0-.162-.137,1.064,1.064,0,0,0-.115-.1,1.074,1.074,0,0,0-.162-.065.959.959,0,0,0-.163-.066L18.755.02a1,1,0,0,0-.39,1.962l1.92.381L2.78,16.222A1,1,0,0,0,3.4,18.006",
    fill: "#8b8d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_396",
    "data-name": "Tracciato 396",
    d: "M25.195,24.039V9.8a1,1,0,0,0-1-1h-3.22a1,1,0,0,0-1,1V24H18.807V13.729a1,1,0,0,0-1-1h-3.22a1,1,0,0,0-1,1V24H12.413V17.755a1,1,0,0,0-1-1H8.193a1,1,0,0,0-1,1V24H6.025V21.779a1,1,0,0,0-1-1H1.8a1,1,0,0,0-1,1v2.26A.987.987,0,0,0,0,25a1,1,0,0,0,1,1H25a1,1,0,0,0,1-1,.985.985,0,0,0-.805-.961M21.975,10.8h1.22V24h-1.22Zm-6.388,3.929h1.22V24h-1.22ZM9.193,18.755h1.22V24H9.193ZM4.025,24H2.805V22.779h1.22Z",
    fill: "#8b8d8e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/job-icon.f35cbff770eadfcf5e35ed9eef10170f.svg";
export { ForwardRef as ReactComponent };